module.exports = __webpack_public_path__ + "media/1x1/pt-04fa443d.svg";